import {
  zlbApiSopArticleArticleCodeGet,
  zlbApiSopNoticeDeleteNoticeCodeDelete,
  zlbApiSopNoticeListPost,
  zlbApiSopNoticeNoticeCodeGet,
  zlbApiSopNoticeSavePost,
  zlbApiSopOperationArticleDeletePost,
  zlbApiSopOperationArticleListPost,
  zlbApiSopOperationArticleUpdateStatusPost,
  zlbApiSopTenantArticleDeletePost,
  zlbApiSopTenantArticleListPost,
  zlbApiSopTenantArticleUpdateStatusPost,
  zlbApiSopTenantNoticeDeleteNoticeCodeDelete,
  zlbApiSopTenantNoticeListPost,
  zlbApiSopTenantNoticeNoticeCodeGet,
  zlbApiSopTenantNoticeSavePost,
} from '@/api/zlbSopContent';
import { getUrl } from '@/config/sceneEnum';
import { CompanyType } from '@/entities';
import { query } from '@/utils/request';

// ========================banner 管理-用户中心===================
export const urlCategory = {
  '/banner/manage': CompanyType.Operation,
  '/zoning-backstage/content-banner': CompanyType.Tenant,

  '/notice-config': CompanyType.Operation,
  '/zoning-backstage/content-popup': CompanyType.Tenant,
  '/content/list': CompanyType.Company,

  '/operation/content-article': CompanyType.Operation,
  '/zoning-backstage/content-article': CompanyType.Tenant,
};

const urls = {
  // ===============banner =============================
  getBannerList: {
    [CompanyType.Tenant]: '/api/zlbuser/banner/list',
    [CompanyType.Operation]: '/zlb/operation/banner/list',
  },
  modifyBanner: {
    [CompanyType.Tenant]: '/api/zlbuser/banner/modify',
    [CompanyType.Operation]: '/zlb/operation/banner/modify',
  },
  addBanner: {
    [CompanyType.Tenant]: '/api/zlbuser/banner/add',
    [CompanyType.Operation]: '/zlb/operation/banner/add',
  },
  getBannerDetail: {
    [CompanyType.Tenant]: '/api/zlbuser/banner/detail',
    [CompanyType.Operation]: '/zlb/operation/banner/detail',
  },
  deleteBanner: {
    [CompanyType.Tenant]: '/api/zlbuser/banner/del',
    [CompanyType.Operation]: '/zlb/operation/banner/del',
  },
  switchBanner: {
    [CompanyType.Tenant]: '/api/zlbuser/banner/switch',
    [CompanyType.Operation]: '/zlb/operation/banner/switch',
  },

  // =============== article =========================
  getArticleList: {
    [CompanyType.Tenant]: zlbApiSopTenantArticleListPost,
    [CompanyType.Operation]: zlbApiSopOperationArticleListPost,
  },
  changeArticleStatus: {
    [CompanyType.Tenant]: zlbApiSopTenantArticleUpdateStatusPost,
    [CompanyType.Operation]: zlbApiSopOperationArticleUpdateStatusPost,
  },
  saveArticle: {
    [CompanyType.Tenant]: '/zlb/api/sop/tenant/article/save',
    [CompanyType.Operation]: '/zlb/api/sop/operation/article/save',
    [CompanyType.Company]: '/zlb/api/sop/org/article/save',
  },
  fetchArticleDetail: {
    [CompanyType.Tenant]: zlbApiSopArticleArticleCodeGet,
    [CompanyType.Operation]: zlbApiSopArticleArticleCodeGet,
    [CompanyType.Company]: zlbApiSopArticleArticleCodeGet,
  },
  deleteArticle: {
    [CompanyType.Tenant]: zlbApiSopTenantArticleDeletePost,
    [CompanyType.Operation]: zlbApiSopOperationArticleDeletePost,
  },
  // =============== 弹窗popup =========================
  getPopupList: {
    [CompanyType.Tenant]: zlbApiSopTenantNoticeListPost,
    [CompanyType.Operation]: zlbApiSopNoticeListPost,
  },
  fetchPopupDetail: {
    [CompanyType.Tenant]: zlbApiSopTenantNoticeNoticeCodeGet,
    [CompanyType.Operation]: zlbApiSopNoticeNoticeCodeGet,
  },
  deletePopup: {
    [CompanyType.Tenant]: zlbApiSopTenantNoticeDeleteNoticeCodeDelete,
    [CompanyType.Operation]: zlbApiSopNoticeDeleteNoticeCodeDelete,
  },
  savePopup: {
    [CompanyType.Tenant]: zlbApiSopTenantNoticeSavePost,
    [CompanyType.Operation]: zlbApiSopNoticeSavePost,
  },
};
/**
 * 分页获取branner列表
 * @param data
 * @returns
 * 接口文档：https://yapi.cai-inc.com/project/3005/interface/api/313514
 */
export function getBannerList(params) {
  return query(urls.getBannerList[urlCategory[getUrl()]], {
    params,
  });
}

/**
 * Banner 修改接口
 * @param data
 * @returns
 * 接口文档：https://yapi.cai-inc.com/project/3005/interface/api/313530
 */
export function modifyBanner(params) {
  return query(urls.modifyBanner[urlCategory[getUrl()]], { method: 'POST', data: params });
}

/**
 * Banner 新增接口
 * @param data
 * @returns
 * 接口文档：https://yapi.cai-inc.com/project/3005/interface/api/313506
 */
export function addBanner(params) {
  return query(urls.addBanner[urlCategory[getUrl()]], { method: 'POST', data: params });
}

/**
 * Banner 获取详情
 * @param data
 * @returns
 * 接口文档：https://yapi.cai-inc.com/project/3005/interface/api/313538
 */
export function getBannerDetail(params) {
  return query(urls.getBannerDetail[urlCategory[getUrl()]], { method: 'GET', params });
}

/**
 * Banner 删除接口
 * @param data
 * @returns
 * 接口文档：https://yapi.cai-inc.com/project/3005/interface/api/313538
 */
export function deleteBanner(params) {
  return query(urls.deleteBanner[urlCategory[getUrl()]], { method: 'POST', data: params });
}

/**
 * 启用或者停用 Banner
 * @param data
 * @returns
 * 接口文档：https://yapi.cai-inc.com/project/3005/interface/api/313498
 */
export function switchBanner(params) {
  return query(urls.switchBanner[urlCategory[getUrl()]], { method: 'POST', data: params });
}

// =========================文章管理==================================
/**
 * 文章列表
 */
export function getArticleList() {
  return urls.getArticleList[urlCategory[getUrl()]];
}

/**
 * 启用停用状态修改
 */
export function changeArticleStatus() {
  return urls.changeArticleStatus[urlCategory[getUrl()]];
}

/**
 * 编辑文章
 */
export function saveArticle(data) {
  return query(urls.saveArticle[urlCategory[getUrl()]], { method: 'POST', data });
}

/**
 * 查询文章详情
 */
export function fetchArticleDetail() {
  return urls.fetchArticleDetail[urlCategory[getUrl()]];
}

/**
 * 删除文章
 */
export function deleteArticle() {
  return urls.deleteArticle[urlCategory[getUrl()]];
}

export async function reqList(data) {
  return query('/zlb/api/sop/org/article/list', {
    method: 'POST',
    data,
  });
}
export async function reqDetail(params) {
  return query(`/zlb/api/sop/article/${params.contentCode}`);
}

// 单位侧-租户分组树
export async function getOrgArticleGrounpTree(params) {
  return query('/zlb/api/sop/org/article/group/tree', {
    method: 'GET',
    params,
  });
}

// 单位侧-删除文章
export async function deleteCompanyArticle(data) {
  return query('/zlb/api/sop/org/article/delete', {
    method: 'POST',
    data,
  });
}

// =========================弹窗管理==================================

/**
 * 弹窗列表
 */
export function getPopupList() {
  return urls.getPopupList[urlCategory[getUrl()]];
}

/**
 * 编辑弹窗
 */
export function savePopup() {
  return urls.savePopup[urlCategory[getUrl()]];
}

/**
 * 查询弹窗详情
 */
export function fetchPopupDetail() {
  return urls.fetchPopupDetail[urlCategory[getUrl()]];
}

/**
 * 删除弹窗
 */
export function deletePopup() {
  return urls.deletePopup[urlCategory[getUrl()]];
}

// =========================内容中心-分组管理==================================

// 治理端-文章分组树
export function getArticleGrounpTree(params) {
  return query('/zlb/api/sop/article/group/tree', {
    params,
  });
}

// 治理端-文章分组树
export function saveArticleGrounp(data) {
  return query('/zlb/api/sop/article/group/save', {
    method: 'POST',
    data,
  });
}

// 治理端-文章分组树
export function updateArticleGrounp(data) {
  return query('/zlb/api/sop/article/group/update', {
    method: 'POST',
    data,
  });
}

// 治理端-删除分组
export function deleteArticleGrounp(data) {
  return query('/zlb/api/sop/article/group/delete', {
    method: 'POST',
    data,
  });
}

// 治理端-移动分组
export function moveGrounp(data) {
  return query('/zlb/api/sop/article/group/move', {
    method: 'POST',
    data,
  });
}

// 治理端-移动文章
export function moveArticle(data) {
  return query('/zlb/api/sop/tenant/article/move', {
    method: 'POST',
    data,
  });
}

// 治理端-批量移动文章
export function batchMoveArticle(data) {
  return query('/zlb/api/sop/tenant/article/batch-move', {
    method: 'POST',
    data,
  });
}

// 治理端-获取文章类型
export function getArticleType(params) {
  return query('/zlb/api/sop/article/group/type/info', {
    params,
  });
}

// 治理端-获取文章类型顺序列表
export function getArticleGroupSeqList(params) {
  return query('/zlb/api/sop/article/group/seq-list', {
    params,
  });
}

// 治理端-编辑文章类型顺序列表
export function editArticleGroupSeq(data) {
  return query('/zlb/api/sop/article/group/seq-edit', {
    data,
    method: 'POST',
  });
}
